import axiosApiInstance from '@/api/axios'
import { FiltersCollectionModel, ResellersModel } from './models/ResellersModel'

class ResellersService {
  async getResellers(data: FiltersCollectionModel): Promise<ResellersModel> {
    const res = await axiosApiInstance.post(`/Resellers/byFilter`, data)

    return res.data
  }
}

export default new ResellersService()
